import { render, staticRenderFns } from "./ProjectJournalsPure.vue?vue&type=template&id=172fdaac&scoped=true&"
import script from "./ProjectJournalsPure.vue?vue&type=script&lang=ts&"
export * from "./ProjectJournalsPure.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectJournalsPure.vue?vue&type=style&index=0&id=172fdaac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172fdaac",
  null
  
)

export default component.exports